import React, { useState } from 'react';

import type { Props as TimeFormat } from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import useTimer from '@swf/core/hooks/useTimer';

import styles from './CurrentTime.scss';
import ClockIcon from './assets/clock-icon.svg';

export const timeFormatProps: TimeFormat = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  date: new Date().getTime()
};

const CurrentTime: React.FC = () => {
  const [time, setTime] = useState(new Date().getTime());
  const timeUpdater = (seconds: number) => {
    const newDate = new Date();
    const timeSeconds = newDate.getSeconds();

    if (timeSeconds === 0) {
      setTime(newDate.getTime());
    }

    return seconds;
  };

  useTimer({ modifier: timeUpdater });

  return (
    <div className={styles.container}>
      <ClockIcon />
      <FormattedTimeZone {...timeFormatProps} date={time} />
    </div>
  );
};

export default CurrentTime;
